// Library imports
import styled from 'styled-components';
// Parent styles
export { InnerContent } from '../styles';

// Container for vs opponent tab layout
export const VsOpponentContainer = styled.div`
    display: flex;
    gap: 1rem;
    flex-direction: column;
`;

// Container for historical games section
export const HistoricalGamesContainer = styled.div`
    display: flex;
    gap: 1rem;
    margin-top: 1rem;
`;

// Individual pitcher section
export const PitcherSection = styled.div`
    flex: 1;
`;

// Pitcher title
export const PitcherTitle = styled.h4`
    margin: 0 0 0.5rem 0;
    color: ${props => props.color || '#e2e8f0'};
    font-size: 1rem;
    font-weight: bold;
    text-shadow: 0 1px 0 rgba(0, 0, 0, 0.6), 0 0 8px rgba(15, 23, 42, 0.45);
`;

// Clickable pitcher name wrapper
export const PitcherLink = styled.span`
    color: ${props => props.color || '#e2e8f0'};
    font-weight: 600;
    cursor: ${props => (props.clickable ? 'pointer' : 'default')};
    text-decoration: ${props => (props.clickable ? 'underline dotted' : 'none')};
    text-decoration-color: ${props => (props.clickable ? 'rgba(147, 197, 253, 0.75)' : 'transparent')};
    &:hover {
        opacity: ${props => (props.clickable ? 0.92 : 1)};
        color: ${props => (props.clickable ? '#dbeafe' : props.color || '#e2e8f0')};
    }
`;

// Starter header row
export const StarterHeaders = styled.div`
    display: flex;
    margin-bottom: 0.5rem;
    font-size: 0.8rem;
`;

// Games count info
export const GamesInfo = styled.div`
    font-size: 0.85rem;
    color: #94a3b8;
    margin-bottom: 0.5rem;
`;

// Games list container
export const GamesListContainer = styled.div`
    max-height: 300px;
    overflow-y: auto;
`;

// Individual game card
export const GameCard = styled.div`
    padding: 8px 12px;
    margin: 4px 0;
    border: 1px solid rgba(148, 163, 184, 0.22);
    border-radius: 6px;
    cursor: pointer;
    background-color: ${props => (props.won ? 'rgba(34, 197, 94, 0.12)' : 'rgba(239, 68, 68, 0.12)')};
    border-left: 4px solid ${props => (props.won ? '#22c55e' : '#ef4444')};
    transition: all 0.2s ease;
    font-size: 0.85rem;
    color: #e2e8f0;

    &:hover {
        background-color: ${props => (props.won ? 'rgba(34, 197, 94, 0.2)' : 'rgba(239, 68, 68, 0.2)')};
        transform: translateX(2px);
    }
`;

// Game date and result
export const GameDateResult = styled.div`
    font-weight: bold;
    margin-bottom: 2px;
`;

// Game score info
export const GameScore = styled.div`
    color: #cbd5e1;
`;

// Opposing pitcher info
export const OpposingPitcher = styled.div`
    color: #94a3b8;
    font-size: 0.8rem;
    margin-top: 2px;
`;

// Empty state for no games
export const NoGamesFound = styled.div`
    padding: 20px;
    text-align: center;
    color: #94a3b8;
    border: 2px dashed rgba(148, 163, 184, 0.3);
    border-radius: 6px;
`;
